import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { Typography } from '@mui/material'

import { useTranslation } from 'shared/hooks/useSafeTranslation'
import { createInputObject } from 'shared/utils/stepsUtils'
import StepPageLayout from 'shared/StepPageLayout'
import useStyles from 'shared/hooks/useStyle'

import styles from './AssetNumber.style'

const propTypes = {
    step: PropTypes.shape({ stepName: PropTypes.string.isRequired }).isRequired,
    assetNumber: PropTypes.string.isRequired,
    inputCallback: PropTypes.func,
    isSummaryView: PropTypes.bool,
}

const AssetNumber = ({
    step,
    assetNumber,
    inputCallback,
    isSummaryView = false,
}) => {
    const { t } = useTranslation()
    const classes = useStyles(styles)

    useEffect(() => {
        if (inputCallback) {
            const input = createInputObject({ assetNumber })

            inputCallback(input, step.stepName)
        }
    }, [
        inputCallback,
        step,
        assetNumber,
    ])

    return (
        <StepPageLayout
            title={t('CONTAINER_SCANNED')}
            isRequired
            isAnswered
            isSummaryView={isSummaryView}
        >
            <Typography
                variant="h3"
                css={classes.text}
            >
                {t('SELECTED_CONTAINER')}
                <span css={classes.assetNumber}>{assetNumber}</span>
            </Typography>
            { !isSummaryView && (
                <Typography
                    variant="h3"
                    css={classes.text}
                >
                    {t('SAVE_PROCESS')}
                </Typography>
            )}
        </StepPageLayout>
    )
}

AssetNumber.propTypes = propTypes

export default AssetNumber
